import React, { useEffect, useState } from "react";
import Drawer from "./components/Drawer/Drawer";
import LocationFinder from "./components/OrderPicker/LocationFinder/LocationFinder";
import Modal from "./components/Modal/Modal";
import "./index.scss"
import { useDispatch, useSelector } from "react-redux";
import MenuNavbar from "./components/Navbar/MenuNavbar";
import LeftDrawer from "./components/Drawers/LeftDrawer/LeftDrawer";
import MenuFooter from "./components/Footer/MenuFooter/MenuFooter";
import RightDrawerCart from "./components/Drawers/RightDrawerCart/RightDrawerCart";
import CollectionStorePicker from "./components/Drawers/CollectionStorePicker/CollectionStorePicker";
import DeliveryAddressPicker from "./components/Drawers/DeliveryAddressPicker/DeliveryAddressPicker";
import HospitalityLoginModal from "./pages/V2/Auth/HospitalityLoginModal/HospitalityLoginModal";
import OfferModal from "./pages/V2/OfferPage/OfferModal/OfferModal";
import { setPreparationSettings, setStoreClosed } from "../../../../../redux/companyDataSlice";
import ScheduleOrderModal from "./pages/V2/ScheduleOrderModal/ScheduleOrderModal";
import { getPreparationSettings } from "../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../utilities/helper";
import { useHistory } from "react-router";
import { setOrderData, setSelectedOrderType } from "../../../../../redux/resturantWidgetSlice";
import { updateOrderTypeDetails } from "../RestaurantWidget/utilities/api/restaurantsService";

const HospitalityPageWrapperV2 = ({ children }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)
    const [addDeliveryLoc, setAddDeliveryLoc] = useState(false);
    const [deliverySuccess, setDeliverySuccess] = useState(false);
    const [deliveryFailed, setDeliveryFailed] = useState(false);
    const [checkoutFailed, setCheckoutFailed] = useState("");
    const [isStoreClosed, setIsStoreClosed] = useState(false);
    const [isLeftDrawerOpen, setIsLeftDrawerOpen] = useState(false);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [collectionStore, setCollectionStore] = useState(false);
    const [deliveryPicker, setDeliveryPicker] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isError, setIsError] = useState(false)
    const [isOrderSuccess, setIsOrderSuccess] = useState(false);
    const [isStoreBlocked, setIsStoreBlocked] = useState(false);
    const [isStoreOrderBlocked, setIsStoreOrderBlocked] = useState(false);
    const [isScheduleError, setIsScheduleError] = useState(false);
    const [isScheduleTimeError, setIsScheduleTimeError] = useState(false);
    const [schedModal, setSchedModal] = useState(
        localStorage.getItem("failedDeliveryOpt") && localStorage.getItem("failedDeliveryOpt") === "true" && localStorage.getItem("schedule_order") ? true : false
    );




    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);

    const selectedOffer = useSelector((state) => state.companyData.selectedOffer);
    const enableSchdeulOrders = companyDetails?.settings?.EnableScheduledOrder || false
    const acceptOrders = companyDetails?.settings?.OnlineOrder?.AcceptOrders || true

    const dispatch = useDispatch()
    const history = useHistory()
    useEffect(() => {
        const fetchData = async () => {
            if (company) {
                let locationID = company?.LocationID
                getPreparationSettings(locationID).then((response) => {
                    dispatch(setPreparationSettings(response))
                })


            }
            else {
                history.push("/")
            }
        }
        fetchData()
    }, [company])
    const isOrderAvailableNow = (type) => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const orderSettings =
            type === "delivery"
                ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Delivery
                : type === "collection"
                    ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Takeaway
                    : companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.DineIn;

        const todaySchedule = orderSettings?.find(day => day.Day === currentDay);
        if (!todaySchedule?.OpenHours?.length) return false;

        for (let hours of todaySchedule.OpenHours) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }

        return false;
    };

    const getMappedOrderType = (orderType) => {
        switch (orderType) {
            case "delivery":
                return "DELIVERY_BY_REWARDCONSUMER";
            case "collection":
                return "TAKE_AWAY";
            case "table":
                return "DINE_IN";
            default:
                return "DELIVERY_BY_REWARDCONSUMER";
        }
    };

    const isBlockedByDateRange = (type) => {
        const orderType = getMappedOrderType(type)
        const now = new Date();
        const data = companyDetails?.settings?.OnlineOrder?.BlockOrdersByType ?? []
        for (const item of data) {
            for (const range of item.DateRanges) {
                const start = new Date(range.StartDate);
                const end = new Date(range.EndDate);
                const localStart = new Date(
                    start.getUTCFullYear(),
                    start.getUTCMonth(),
                    start.getUTCDate(),
                    start.getUTCHours(),
                    start.getUTCMinutes(),
                    start.getUTCSeconds()
                );

                const localEnd = new Date(
                    end.getUTCFullYear(),
                    end.getUTCMonth(),
                    end.getUTCDate(),
                    end.getUTCHours(),
                    end.getUTCMinutes(),
                    end.getUTCSeconds()
                );
                if (now >= localStart && now <= localEnd) {
                    if (item.BlockedFulfillmentTypes.includes(orderType)) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    const handleStoreClose = () => {
        const types = ["delivery", "collection", "table"];
        const isClosed = {};
        for (const type of types) {
            isClosed[type] = isBlockedByDateRange(type) || !isOrderAvailableNow(type);
        }
        return isClosed;
    };
    const isBlockedHour = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.settings?.OnlineOrder?.BlockedHours.find(day => day.Day === currentDay);
        if (!today) return false;

        for (let hours of today.Time) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    const isStoreOpen = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        let currentHours = now.getHours();
        let currentMinutes = now.getMinutes();
        let currentTime = currentHours * 60 + currentMinutes;

        const today = companyDetails?.openingHours?.find(day => day.Day === currentDay);
        if (!today || today.Closed) return false;

        for (let hours of today.OpenHours) {
            let [startH, startM] = hours.StartTime.split(':').map(Number);
            let [endH, endM] = hours.EndTime.split(':').map(Number);
            let startTime = startH * 60 + startM;
            let endTime = endH * 60 + endM;

            if (endTime < startTime) {
                endTime += 24 * 60;
                if (currentTime < startTime) currentTime += 24 * 60;
            }

            if (currentTime >= startTime && currentTime <= endTime) {
                return true;
            }
        }
        return false;
    }
    useEffect(() => {
        if (companyDetails) {
            if (enableSchdeulOrders) {
                let sched = localStorage.getItem("schedule_order")
                if (sched) {
                    setIsStoreClosed(false)
                } else {
                    if (selectedOrderType !== "") {
                        setIsStoreClosed(!isStoreOpen() || isBlockedHour() || handleStoreClose()[selectedOrderType])
                    }
                }
            } else {
                setIsStoreClosed(!isStoreOpen())
                setIsStoreBlocked(isBlockedHour())
            }
            dispatch(setStoreClosed(handleStoreClose()))
        }
    }, [companyDetails, selectedOrderType])
    const updateOrderType = (type) => {
        let body = {
            "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID),
            "DeliveryType": type,
            "CountryCode": "GB"
        }
        updateOrderTypeDetails(body).then((res) => {
            dispatch(setOrderData(res))
        })

    }
    return (
        <>
            <div className="hospit-page-wrapper">
                <LocationFinder visibility={addDeliveryLoc}
                    setAddDeliveryLoc={setAddDeliveryLoc}
                    onPopupClose={() => {
                        setAddDeliveryLoc(false)
                    }}

                    setDeliverySuccess={setDeliverySuccess}
                    setDeliveryFailed={setDeliveryFailed}
                />
                <CollectionStorePicker
                    isOpen={collectionStore}
                    setIsOpen={setCollectionStore}
                />
                <DeliveryAddressPicker
                    isOpen={deliveryPicker}
                    setIsOpen={setDeliveryPicker}
                />
                <Modal visibility={deliverySuccess} type="success" headerText="Great news! We deliver to your location" subText="Enjoy fresh and fast delivery straight to your doorstep. Place your order now!" onPopupClose={() => {
                    setDeliverySuccess(false)
                }} />
                <Modal visibility={deliveryFailed} type="failed" headerText="Uh-oh! Looks like we can’t reach you" subText={`Sorry, we don’t currently deliver to your area. Stay tuned for updates!`} onPopupClose={() => {
                    setDeliveryFailed(false)
                }} />
                <Modal visibility={checkoutFailed !== ""} type="failed" headerText="Sorry!" subText={checkoutFailed} onPopupClose={() => {
                    setCheckoutFailed("")
                }} />
                <MenuNavbar
                    setIsDrawerOpen={setIsDrawerOpen}
                    setAddDeliveryLoc={setAddDeliveryLoc}
                    setIsLeftDrawerOpen={setIsLeftDrawerOpen}
                    setIsCartOpen={setIsCartOpen}
                    setCollectionStore={setCollectionStore}
                    setShowLogin={setIsModalVisible}
                    setIsStoreClosed={setIsStoreClosed}
                />
                {isDrawerOpen && <Drawer setIsDrawerOpen={setIsDrawerOpen} />}
                {children}
                {!enableSchdeulOrders ? <>
                    <Modal visibility={isStoreClosed} type="closed" headerText=" We’ll Be Back Soon!" subText={
                        "We're sorry, but the store is currently closed. Please check our hours and visit us later!"
                    } onPopupClose={() => {
                        setIsStoreClosed(false)
                    }}
                        btnText={"VIEW STORE"} />
                    <Modal visibility={isStoreBlocked} headerText="We're Taking a Short Break" subText={
                        "Our store is currently closed for orders. We'll be back soon to serve you better. Thank you for your patience!"
                    } onPopupClose={() => {
                        setIsStoreBlocked(false)
                    }}
                        btnText={"VIEW STORE"} />
                </> :
                    <ScheduleOrderModal visibility={isStoreClosed && !deliverySuccess && !deliveryFailed}
                        onPopupClose={() => {
                            setIsStoreClosed(false)
                        }}
                    />}
                <LeftDrawer
                    isOpen={isLeftDrawerOpen}
                    setIsOpen={setIsLeftDrawerOpen}
                    showLogin={() => {
                        setIsLeftDrawerOpen(false)
                        setIsModalVisible(true)
                    }}
                />
                <RightDrawerCart
                    isOpen={isCartOpen}
                    setIsOpen={setIsCartOpen}
                    setCheckoutFailed={setCheckoutFailed}
                    isStoreOpen={isStoreOpen}
                    setIsStoreClosed={setIsStoreClosed}
                    setIsStoreOrderBlocked={setIsStoreOrderBlocked}
                    setIsScheduleError={setIsScheduleError}
                    setIsScheduleTimeError={setIsScheduleTimeError}
                />
                <HospitalityLoginModal
                    visibility={isModalVisible}
                    fromCheckout={false}
                    onPopupClose={() => {
                        setIsModalVisible(false)
                    }}
                    setIsError={setIsError} />
                <OfferModal
                    visibility={selectedOffer !== ""}
                    setIsOrderSuccess={setIsOrderSuccess}
                />
                <Modal visibility={isOrderSuccess} type="success"
                    headerText="Item Added to Cart!"
                    subText="Great choice! Your item is saved in the cart and ready for checkout."
                    onPopupClose={() => {
                        setIsOrderSuccess(false)
                    }}
                />
                <Modal visibility={isError} type="failed" headerText="Invalid Login" subText="Invalid email address or password"
                    onPopupClose={() => {
                        setIsError(false)
                    }}
                />
                <Modal visibility={isStoreOrderBlocked} type="failed" headerText={selectedOrderType + " Unavailable"} subText={`Store is not accepting ${selectedOrderType} orders at the moment. Would you like to switch your order type to ${selectedOrderType === "collection" ? "delivery" : "collection"} instead?`}
                    onPopupClose={() => {
                        let type = selectedOrderType === "collection" ? "delivery" : "collection"
                        if (type === "collection") {
                            dispatch(setSelectedOrderType("collection"))
                            updateOrderType("TAKE_AWAY")
                        } else {
                            setAddDeliveryLoc(true)
                        }
                        setIsStoreOrderBlocked(false)
                    }}
                />
                <Modal visibility={isScheduleError} type="failed" headerText="Store is Currently Closed" subText="Please schedule your order for a later time to proceed to checkout."
                    onPopupClose={() => {
                        setIsScheduleError(false)
                        setIsStoreClosed(true)
                    }}
                />
                <Modal visibility={isScheduleTimeError} type="failed" headerText="Scheduled Time Has Passed" subText=" Please update the scheduled time to proceed with your order."
                    onPopupClose={() => {
                        setIsScheduleTimeError(false)
                        setIsStoreClosed(true)
                    }}
                />
                <Modal visibility={schedModal} type="failed" headerText=" Scheduled Time May Be Affected!" subText={`Sorry, Please review your scheduled order time. It may no longer be valid with the new ordering type. Adjust the schedule if necessary.`} onPopupClose={() => {
                    localStorage.removeItem("failedDeliveryOpt")
                    setSchedModal(false)
                    localStorage.removeItem("schedule_order")
                    setIsStoreClosed(true)
                }} />
                <MenuFooter />
            </div>

        </>
    );
}

export default HospitalityPageWrapperV2;